// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__3h6vp","nav":"Layout_nav__1PpKP","trend":"Layout_trend__1cJlB"};